export class OrgaoJulgador{
    id = 0;
    descricao = '';
    situacao: Boolean;
}